<div class="rg-app-shell">
    <aside class="rg-sidebar">
        <div class="rg-brand">
            <div class="rg-logo">
                <!-- <i class="bi bi-shield-lock-fill"></i> -->
                <div class="brand-mark">RG</div>
            </div>

            <div>
                <div class="rg-brand-title">RiskGuard</div>
                <small>Licensing Admin</small>
            </div>
        </div>
        <div class="rg-mobile-bar">
            <button class="btn btn-outline-dark btn-sm" (click)="toggleSidebar()">
                <i class="bi bi-list"></i>
            </button>

            <strong>RiskGuard Licensing</strong>
        </div>

        <div class="rg-sidebar-backdrop" *ngIf="sidebarOpen" (click)="closeSidebar()">
        </div>

        <nav class="rg-nav">
            <a routerLink="/dashboard" routerLinkActive="active" class="rg-nav-link" (click)="closeSidebar()">
                <i class="bi bi-grid-1x2-fill"></i>
                <span>Dashboard</span>
            </a>

            <a routerLink="/organizations" routerLinkActive="active" class="rg-nav-link" (click)="closeSidebar()">
                <i class="bi bi-buildings-fill"></i>
                <span>Organizations</span>
            </a>

            <a routerLink="/validation-logs" routerLinkActive="active" class="rg-nav-link" (click)="closeSidebar()">
                <i class="bi bi-activity"></i>
                <span>Validation Logs</span>
            </a>

            <a routerLink="/audit-logs" routerLinkActive="active" class="rg-nav-link" (click)="closeSidebar()">
                <i class="bi bi-journal-text"></i>
                <span>Audit Logs</span>
            </a>

            <a *ngIf="isSuperAdmin" routerLink="/admin-users" routerLinkActive="active" class="rg-nav-link"
                (click)="closeSidebar()">
                <i class="bi bi-people-fill"></i>
                <span>Admin Users</span>
            </a>
            <a routerLink="/password-reset-requests" routerLinkActive="active" class="rg-nav-link"
                (click)="closeSidebar()">
                <i class="bi bi-shield-lock-fill"></i>
                <span>Password Requests</span>
            </a>
            <a routerLink="/settings" routerLinkActive="active" class="rg-nav-link" (click)="closeSidebar()">
                <i class="bi bi-gear-fill"></i>
                <span>Settings</span>
            </a>
        </nav>

        <div class="rg-sidebar-footer">
            <small class="text-white-50">Logged in as</small>
            <div class="fw-semibold text-truncate">{{ adminName }}</div>
            <small class="text-white-50 text-truncate d-block">{{ adminEmail }}</small>

            <button class="btn btn-sm btn-outline-light w-100 mt-3" routerLink="/profile" (click)="closeSidebar()">
                <i class="bi bi-person-circle me-1"></i>
                Profile
            </button>

            <button class="btn btn-sm btn-outline-light w-100 mt-3" (click)="logout()">
                <i class="bi bi-box-arrow-right me-1"></i>
                Logout
            </button>
        </div>
    </aside>

    <main class="rg-main">
        <router-outlet></router-outlet>
    </main>
</div>
